<script setup>
import { ref } from 'vue'
import { useAuthStore } from '../stores/auth.store'

const $auth = useAuthStore()

const username = ref($auth.user || '')
const password = ref('')

const loading = ref(false)
const errorText = ref('')

async function Login() {
  errorText.value = ''
  loading.value = true
  try {
    const res = await $auth.login(username.value, password.value)
    if (!res.ok) {
      errorText.value = res.message
        // res.status === 0 || !res.status
        //   ? 'Нет соединения с сервером (возможна блокировка сети/провайдера).'
        //   : `Не удалось войти: ${res.message}`
    }
  } finally {
    loading.value = false
  }
}

// Handlers
//onBeforeMount(async () => {})
</script>

<template>
  <v-container>
    <h1>Авторизация</h1>

    <v-alert v-if="errorText" type="error" variant="tonal" class="mb-3">
      {{ errorText }}
    </v-alert>

    <v-text-field v-model="username" label="Имя пользователя" />
    <v-text-field v-model="password" type="password" label="Пароль" />

    <v-btn :loading="loading" :disabled="loading" prepend-icon="mdi-login" @click="Login">
      Войти
    </v-btn>
  </v-container>
</template>

<style lang="less" scoped>
.loader {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .text {
    margin-left: 10px;
    font-size: 1.2rem;
  }
}
</style>
